module.exports = __webpack_public_path__ + "img/DCI_LOCAL.9b137e78.svg";